import { render, staticRenderFns } from "./wxPhoneParent.vue?vue&type=template&id=d762993c"
import script from "./wxPhoneParent.vue?vue&type=script&lang=ts"
export * from "./wxPhoneParent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports